/* eslint-disable import/prefer-default-export */
import { createGesture } from '@ionic/core';

// Returns a cleanup fn. Callers should run it when the overlay closes: the gesture is
// bound to a shadow node that outlives a single open, so re-opening otherwise stacks gestures.
export const swipeDown = (elem, handle) => {
  let gesture = null;

  const timeout = setTimeout(() => {
    const container = elem;
    let swipeElem = '';
    let handleElem = null;

    if (handle?.current) {
      handleElem = handle.current;
    }

    if (container?.current?.nodeName === 'ION-POPOVER') {
      swipeElem = container.current.shadowRoot.querySelector('.popover-content');
    } else {
      swipeElem = container.current;
    }
    if (swipeElem) {
      const resetPosition = () => {
        swipeElem.style.bottom = '';
        swipeElem.style.transition = '';
      };

      gesture = createGesture({
        el: handleElem || swipeElem,
        gestureName: 'swipe-down-close',
        direction: 'y',
        threshold: 30,
        onStart: () => {
          swipeElem.style.transition = 'bottom 50ms linear';
        },
        onMove: event => {
          swipeElem.style.bottom = `-${event.deltaY}px`;
        },
        onEnd: event => {
          if (event.deltaY > 100) {
            // Reset only once the leave animation has finished — the drag offset lives on the
            // shadow content, which survives the dismiss and would push the next open off-screen.
            // The ref is null if the overlay unmounted mid-drag; onEnd still fires on pointer-up.
            const dismissed = container.current?.dismiss();
            if (dismissed?.then) {
              dismissed.then(resetPosition, resetPosition);
            } else {
              resetPosition();
            }
          } else {
            resetPosition();
          }
        }
      });
      gesture.enable(true);
    }
  }, 500);

  return () => {
    clearTimeout(timeout);
    gesture?.destroy?.();
  };
};
